import React, { ReactNode } from 'react';
import SidebarMobile from '../components/Sidebar-mobile';
import SidebarDesktop from '../components/Sidebar-desktop';
import Footer from '../components/Footer';
import { navItemsUser } from '../data/NavItemsAdmin';
import Header from '../components/Header';


interface LayoutProps {
  children: ReactNode;
}

const UnitAdminLayout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <div className="wrapper">
      <Header />
      <SidebarMobile navItems={navItemsUser}/>
      <section className="main-page">
        {/* Pass navItemsAdmin to SidebarDesktop */}
        <SidebarDesktop navItems={navItemsUser}/>
        {children}
      </section>
      <Footer />
    </div>
  );
};

export default UnitAdminLayout;
